"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restore = exports.getRootElement = exports.config = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
* @deprecated
* Use ActiveUIProvider instead.
* */

var cfg;
var defaults = function defaults() {
  return {
    rootElement: function rootElement() {
      return (0, _eq["default"])('undefined')(typeof document === "undefined" ? "undefined" : (0, _typeof2["default"])(document)) ? null : (0, _prop["default"])('body')(document);
    }
  };
};

/**
* @deprecated
* Use ActiveUIProvider instead.
* */
var config = exports.config = function config(configuration) {
  cfg = _objectSpread(_objectSpread({}, defaults()), configuration);
};

/**
* @deprecated
* Use ActiveUIProvider instead.
* */
var restore = exports.restore = function restore() {
  cfg = _objectSpread({}, defaults());
};

/**
* @deprecated
* Use ActiveUIProvider instead.
* */
var getRootElement = exports.getRootElement = function getRootElement() {
  return cfg.rootElement();
};
restore();